const apiUrlBase = 'https://webhook.altogiro.com.br/webhook/dados/api/v1/ti/pes/clientescolecao'
const apiKey = 'xAQ8hbgphEytkD8MdWsZFAltVbI6GYfy'

const headers = new Headers({
  apiKey: apiKey
})

const options = {
  method: 'GET',
  headers: headers
}

let stores = []
let actualState = ''
let actualCity = ''

const filterButton = document.querySelector('#storelocator-filter-btn')
const resetButton = document.querySelector('#storelocator-reset-btn')
const selectElementToStates = document.querySelector('#storelocator-state-select')
const selectElementToCities = document.querySelector('#storelocator-city-select')
const storesTable = document.querySelector('#stores-table')
const storesList = document.querySelector('#stores')

filterButton.addEventListener('click', (event) => {
  event.preventDefault()

  if (!actualState) {
    clearStores()
    hideStoresTable()
    return
  }

  renderStores(getFilteredStores())

  selectElementToStates.disabled = true
  selectElementToCities.disabled = true
  filterButton.classList.add('hidden')
  resetButton.classList.remove('hidden')
  showStoresTable()
})

resetButton.addEventListener('click', (event) => {
  event.preventDefault()

  actualState = ''
  actualCity = ''

  hideStoresTable()
  clearStores()
  setupStateSelect()
  resetCitySelect()

  filterButton.classList.remove('hidden')
  resetButton.classList.add('hidden')
  selectElementToStates.disabled = false
  selectElementToCities.disabled = true
  filterButton.disabled = true
})

selectElementToStates.addEventListener('change', (event) => {
  actualState = event.target.value
  actualCity = ''

  setupCitySelect(actualState)
  selectElementToCities.disabled = false
  filterButton.disabled = false
})

selectElementToCities.addEventListener('change', (event) => {
  actualCity = event.target.value
})

function fetchData() {
  fetch(apiUrlBase, options)
    .then(response => {
      if (!response.ok) {
        throw new Error('Erro ao acessar a API')
      }

      return response.json()
    })
    .then(apiData => {
      stores = Array.isArray(apiData) ? apiData : []
      clearStores()
      setupStateSelect()
    })
    .catch(error => {
      console.error('Erro ao processar a solicitação:', error)
    })
}

function getFilteredStores() {
  if (!actualState) {
    return []
  }

  return stores.filter(store => {
    const matchesState = store.state === actualState
    const matchesCity = !actualCity || store.city === actualCity

    return matchesState && matchesCity
  })
}

function renderStores(storesToRender) {
  storesList.innerHTML = ''

  storesToRender.forEach(store => {
    const listItem = document.createElement('li')
    const businessName = document.createElement('p')
    const address = document.createElement('p')
    const phones = document.createElement('p')

    listItem.classList.add('stores-locations')
    listItem.dataset.state = store.state
    listItem.dataset.city = store.city

    businessName.textContent = store.business_name
    address.id = 'stores-address'
    address.textContent = `${store.address}, ${store.city}-${store.state}, ${store.country}`
    phones.textContent = store.phones

    listItem.appendChild(businessName)
    listItem.appendChild(address)
    listItem.appendChild(phones)
    storesList.appendChild(listItem)
  })
}

function clearStores() {
  storesList.innerHTML = ''
}

function showStoresTable() {
  storesTable.style.display = 'block'
}

function hideStoresTable() {
  storesTable.style.display = 'none'
}

function setupStateSelect() {
  const statesList = getUniqueSortedValues(stores, 'state')

  selectElementToStates.innerHTML = '<option value="initial" disabled selected>Estado</option>'

  statesList.forEach(state => {
    const optionItem = document.createElement('option')
    optionItem.textContent = state
    optionItem.value = state
    selectElementToStates.appendChild(optionItem)
  })
}

function setupCitySelect(selectedState) {
  const citiesList = getUniqueSortedValues(
    stores.filter(store => store.state === selectedState),
    'city'
  )

  resetCitySelect()

  citiesList.forEach(city => {
    const optionItem = document.createElement('option')
    optionItem.textContent = city
    optionItem.value = city
    selectElementToCities.appendChild(optionItem)
  })
}

function resetCitySelect() {
  selectElementToCities.innerHTML = '<option value="initial" disabled selected>Cidade</option>'
}

function getUniqueSortedValues(items, key) {
  const values = items
    .map(item => item[key])
    .filter(value => value)

  return Array.from(new Set(values)).sort()
}

fetchData()

